
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-7881a2e2\",\"scoped\":true,\"hasInlineConfig\":false}!scss-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./cooperationInfo.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./cooperationInfo.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7881a2e2\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./cooperationInfo.vue"),
  /* scopeId */
  "data-v-7881a2e2",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./vue/views/basic/cooperationInfo.vue
// module id = 826
// module chunks = 0